module.exports = __webpack_public_path__ + "8e566724b8d6dea55a2378cbbe6014b5.png";